// extracted by mini-css-extract-plugin
module.exports = {"card":"SimulationCard__card","simulationContainer":"SimulationCard__simulationContainer","thumbnail":"SimulationCard__thumbnail","label":"SimulationCard__label"};